import React, { useEffect, useState } from "react";
import "./CommonDashboard.css";
import GridGenerator from "../Common/GridGenerator/GridGenerator";
import {
  centerBannerUrl,
  centerLogoUrl,
  dashboadrText,
} from "../../Services/EndPoints";
import { getData } from "../../Services/Services";

const CommonDashboard = () => {
  const [dashboardText, setDashboardText] = useState("");
  useEffect(() => {
    getData(dashboadrText)
      .then((response) => {
        setDashboardText(response?.text);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  return (
    <div className="main__container">
      <div className="cd__content">
        <div className="cd__banner">
          <img src={centerBannerUrl} className="converge__banner" />
          <div className="banner__overlay">
            <div className="banner__text">
              <img src={centerLogoUrl} className="mx-2" />
              {dashboardText || "Common Dashboard"}
            </div>
          </div>
        </div>
        <div className="cd__cards">
          <GridGenerator />
        </div>
      </div>
    </div>
  );
};

export default CommonDashboard;
